import React from 'react';
import { LocalizationTableRow } from './LocalizationTableRow';

export const LocalizationTable = ({
  projectId,
  localization,
  deleteLocalizationKeyValue,
  language,
  updateLocalizationKeyValue,
  deleteFlag,
  isReadOnly,
}) => {
  const isLocalizedExist = localization && localization.length > 0;
  const localizationLang = localization.find((local) => local.language === language);
  const isKeyandValues = localizationLang && localizationLang.languageKeyValues.length > 0;
  if (!isLocalizedExist || !isKeyandValues)
    return <div className="alert">No Localization Data</div>;

  return (
    <div className="table-responsive">
      <table className="table table-bordered table-word-break">
        <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {localizationLang.languageKeyValues.map((languageKeyValue) => (
            <LocalizationTableRow
              key={languageKeyValue.key}
              projectId={projectId}
              languageKeyValue={{ ...languageKeyValue, language, uuid: localizationLang.uuid }}
              updateLocalizationKeyValue={updateLocalizationKeyValue}
              deleteLocalizationKeyValue={deleteLocalizationKeyValue}
              deleteFlag={deleteFlag}
              isReadOnly={isReadOnly}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};
